import { render, staticRenderFns } from "./LessonSectionAbstract.vue?vue&type=template&id=51559462"
import script from "./LessonSectionAbstract.vue?vue&type=script&lang=js"
export * from "./LessonSectionAbstract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports